import { render } from "./index.vue?vue&type=template&id=9844b36e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=9844b36e&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-9844b36e"

export default script